var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWwStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 70,
    viewBox: "0 0 66 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.3245 68.3869H10.2266C5.27955 68.3869 1.23193 64.3393 1.23193 59.3922V17.7916C1.23193 12.8446 5.27955 8.79694 10.2266 8.79694H56.3245C61.2716 8.79694 65.3192 12.8446 65.3192 17.7916V59.3922C65.3192 64.3393 61.2716 68.3869 56.3245 68.3869Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29932 15.2956V25.9206H65.0493V15.2956C65.0493 15.2956 64.1049 8.74072 57.966 8.21228C51.8271 7.68384 10.2266 8.21228 10.2266 8.21228C10.2266 8.21228 1.29932 8.29098 1.29932 15.2956Z",
    fill: "#63C7C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3411 15.2956V1.12897M19.0078 15.2956V1.12897V15.2956Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29932 25.9207H65.0493",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29932 15.2956V61.3373C1.29932 65.25 4.46995 68.4206 8.38265 68.4206H57.966C61.8787 68.4206 65.0493 65.25 65.0493 61.3373V15.2956C65.0493 11.3829 61.8787 8.21228 57.966 8.21228H8.38265C4.46995 8.21228 1.29932 11.3829 1.29932 15.2956Z",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3478 46.6759C23.9437 47.9014 24.7982 48.9133 25.5403 49.7341C26.912 51.2407 28.4636 52.5787 29.9589 53.8829C30.7684 54.58 31.5667 55.2771 32.3538 55.9967C32.871 56.4689 33.4219 56.705 33.9841 56.705C34.5575 56.705 35.1309 56.4577 35.6818 55.9742C37.1772 54.6362 38.6613 53.3095 40.1342 51.9715C41.6745 50.5661 42.8214 49.3406 43.7433 48.0926C44.8452 46.586 45.3174 44.9332 45.1487 43.1567C44.9688 41.2678 44.0244 39.8287 42.4391 38.9854C39.5833 37.4788 36.2327 37.7711 33.9503 39.66C32.1851 38.1984 29.9702 37.7037 27.5304 38.2321C25.7651 38.6144 24.4946 39.4014 23.6514 40.627C23.1792 41.3016 22.988 42.0211 22.8306 42.6058L22.7856 44.7983L22.8531 45.2143C22.9768 45.6752 23.1005 46.1812 23.3478 46.6759Z",
    fill: "#5458F7",
    stroke: "#353B60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwStep3);
export default __webpack_public_path__ + "static/media/ww-step3.347beeb9.svg";
export { ForwardRef as ReactComponent };